import { styled } from '@mui/material/styles';

export const InsightCardWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  border: ${({ theme }) => `1px solid ${theme.colors.neutral.shades.shade100}`};
  padding: 24px;
  gap: 24px;
  width: 100%;
  min-height: 128px;
  background: white;
  border-radius: 8px;
  min-height: 280px;
`;

export const IconWrapper = styled('div')`
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
`;